import { IconButton } from '@mui/material';
import { IconEdit } from '@nps.today/component-library';
import { FunctionComponent } from 'react';

interface EditListItemProps {
  onClick: () => void;
}

export const EditListItem: FunctionComponent<EditListItemProps> = ({ onClick }) => {
  return (
    <div onClick={onClick}>
      <IconButton>
        <IconEdit />
      </IconButton>
    </div>
  );
};
